import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Link from 'next/link';
import Icon from '../Icon';

import styles from './TabLinksVertical.module.scss';

const TabLinksVertical = ({ primary, secondary }) => {
    const [isMobileExpanded, setIsMobileExpanded] = useState(false);
    const activePage = primary.find(item => item.active === true);

    return (
        <div
            className={classNames(styles['TabLinksVertical'], {
                [styles['TabLinksVertical--Expanded']]: isMobileExpanded,
            })}>
            <button
                className={styles['TabLinksVertical__Button']}
                onClick={() => setIsMobileExpanded(!isMobileExpanded)}>
                <span>
                    <span className={styles['TabLinksVertical__ButtonTag']}>
                        Menu
                    </span>
                    {activePage && (
                        <span className={styles['TabLinksVertical__ButtonText']}>
                            {activePage && activePage.title}
                        </span>
                    )}
                </span>
                <span className={styles['TabLinksVertical__Icon']}>
                    <Icon type={'chevron'} size={'large'} />
                </span>
            </button>
            <nav className={styles['TabLinksVertical__Container']}>
                <div
                    className={
                        styles['TabLinksVertical__PrimaryLinksContainer']
                    }>
                    <ul>
                        {primary &&
                            primary.map((primaryItem, i) => (
                                <li key={i}>
                                    <Link
                                        onClick={() => { setIsMobileExpanded(false) }}
                                        scroll={false}
                                        className={classNames(
                                            styles['TabLinksVertical__PrimaryLink'],
                                            { [styles['TabLinksVertical__PrimaryLink--Active']]: primaryItem.active === true },
                                        )
                                        }
                                        href={primaryItem.href}
                                    >
                                        {primaryItem.title}
                                    </Link>
                                </li>
                            ))}
                    </ul>
                </div>
                <div className={styles['TabLinksVertical__Line']}></div>
                <div
                    className={
                        styles['TabLinksVertical__SecondaryLinksContainer']
                    }>
                    <ul>
                        {secondary &&
                            secondary.map((secondaryItem, index) => (
                                <li key={index}>
                                    <a
                                        className={
                                            styles[
                                            'TabLinksVertical__SecondaryLink'
                                            ]
                                        }
                                        href={secondaryItem.href}
                                    >
                                        {secondaryItem.title}
                                    </a>
                                </li>
                            ))}
                    </ul>
                </div>
            </nav>
        </div>
    );
};

TabLinksVertical.propTypes = {
    primary: PropTypes.array,
    secondary: PropTypes.array,
};

TabLinksVertical.defaultProps = {
    primary: [],
    secondary: []
};

export default TabLinksVertical;
